// src/utilities/context/ScrollContext.tsx
import {createContext, useContext} from 'react';

interface ScrollContextType {
  isScrollingDown: boolean;
  isNearBottom: boolean;
}

export const ScrollContext = createContext<ScrollContextType>({
  isScrollingDown: false,
  isNearBottom: false,
});

export const useScrollContext = () => useContext(ScrollContext);
